<script lang="ts">
  import { onMount } from "svelte"
  import { Chart, Layout } from "../../components"
  import { _ } from "svelte-i18n"
  import { color, type SeriesGanttOptions } from "highcharts"
  import { deleteChannel, getChannel, syncChannel } from "../../services/endpoints"
  import { MediaType } from "../../services/models"
  import { Button } from "@gl/design-system"
  import { navigateCustom, navigateCustomUrl } from "../../utils/navigateCustom"
  import { addMilliseconds, format, parseJSON } from "date-fns"
  import { ISOFormatString } from "../../utils"


  let charts: { [key: string]: SeriesGanttOptions[]} = {}
  let title = $_("common.channel")
  let tooltip = {
    formatter: function () {
        return `<b>StreamKey: </b>${JSON.stringify(this.point.streamKey)}<br><b>Value: </b>${JSON.stringify(this.point.value)}<br><b>Start: </b>${format(new Date(this.point.start), ISOFormatString)}<br><b>End: </b>${format(this.point.end, ISOFormatString)}`;
    }
  }
  export let uuid: string

  function loadSeries() {
    charts = {}
    getChannel(uuid).then((channel) => {
      // let tmpSeries: { [key: string]: SeriesGanttOptions} = {}
      title = `${$_("common.channel")} ${channel.name}`

      for (let stream of channel.streams) {
        if ("collection" in stream) {
          console.error("provided stream was of type Link and not Stream")
          return;
        }

        
        for (let location of stream.locations) {
          let data = []
          for (let t of Object.values(location.timeline)) {
            let start = parseJSON(t.startDateTime)
            data.push({
              start: start.getTime(),
              end: addMilliseconds(start, t.durationMs).getTime(),
              name: stream.type == MediaType.VIDEO ? `Video (${stream.value.width}x${stream.value.height})` : stream.value.language ? `Audio (${stream.value.language})` : "Audio",
              color: stream.type == MediaType.VIDEO ? "#006cca" : "#f98400",
              streamKey: stream.streamKey,
              value: stream.value
            })
          }

          if(!(location.location.uuid in charts)) {
            charts[location.location.uuid] = [
              {
                name: `${location.location.uuid}`,
                data: [],
                dataSorting: {
                  enabled: true,
                }
              }
            ]  
          }

          charts[location.location.uuid][0].data?.push(...data)
          charts[location.location.uuid][0].data = charts[location.location.uuid][0].data?.sort((a, b) => {
            return a.streamKey.streamId - b.streamKey.streamId || b.end - a.end
          })
        }
      }
    })
  }

  onMount(() => {
    loadSeries()
  })

  function _syncChannel() {
    syncChannel(uuid).then(() => loadSeries())
  }

  function _deleteChannel(e) {
    deleteChannel(uuid).then(() => navigateCustom("/channels", e))
  }
</script>
<Layout selected="channels">
  <Button on:click={(e) => navigateCustom("/channels/patch/" + uuid, e)}>{$_("common.update")}</Button>
  <Button on:click={_syncChannel}>{$_("common.sync")}</Button>
  <Button on:click={(e) => _deleteChannel(e)} status="error">{$_("common.delete")}</Button>
  {#each Object.entries(charts) as [key, series] }
  <Chart bind:series title={ `${title} <a href="${navigateCustomUrl("/locations/" + key)}">${key}</a>`} {tooltip}></Chart>
  {/each}
</Layout>
